import { Link } from "react-router-dom";

const ThanksModal = () => {
  return (
    <div className={`relative flex flex-col justify-start items-center top-[210px] left-[420px] w-[233.5px] h-[200px] text-darkslategray`}>
      <div className={`rounded-mini bg-white shadow-[-10.383894920349121px_-8.495914459228516px_28.32px_rgba(0,_0,_0,_0.35),_12.271876335144043px_11.327885627746582px_28.32px_rgba(0,_0,_0,_0.35)] backdrop-blur-lg absolute inset-0 w-[233.5px] h-[200px]`} />
      <div className="z-0 mt-[13px] font-semibold text-yellowgreen w-[135.03px] h-[24.05px]">
        Thanks!
      </div>
      <img
        className="z-0 mt-[5px] w-[235.5px] h-0.25"
        alt=""
        src="/seprator.svg"
      />
      <div className="z-0 mt-[10px] mb-[10px] text-[10px] mx-3 w-[180px] text-center">
        Congratulations on completing the OneScreen L7 Interactive Guide!
        We hope you enjoyed getting to know your L7 device. Please click the
        "Retake" button to review the same demo or the "Details" button to
        explore our features further.
      </div>
      <img
        className="z-0 mt-[0px] w-[245.5px] h-0.25"
        alt=""
        src="/vector-9.svg"
      />
      <div className="absolute h-[20px] w-[67.01%] top-[86%] right-[16.4%] bottom-[5.76%] left-[16.59%]">
        <Link to="/" className="decoration-transparent">
          <div className="absolute h-full w-[47.85%] top-[0%] right-[52.15%] bottom-[0%] left-[0%]">
            <div className="absolute h-full w-full top-[0%] right-[0%] bottom-[0%] left-[0%] rounded-mini bg-lightsteelblue" />
            <div className="absolute text-darkslategray text-[9px] w-full top-[23.33%] left-[0%] inline-block">
              Retake
            </div>
          </div>
        </Link>
        <Link to="https://www.youtube.com/embed/playlist?list=PLZP7o2aOzdejgC55WDzoT3PItj-geu4r9" className="decoration-transparent">
          <div className="absolute h-full w-[47.85%] top-[0%] right-[0%] bottom-[0%] left-[52.15%] text-white">
            <div className="absolute h-full w-full top-[0%] right-[0%] bottom-[0%] left-[0%] rounded-[25px] bg-yellowgreen" />
            <div className="absolute text-[9px] w-full top-[20%] left-[0%] inline-block hover: cursor-pointer">
              Details
            </div>
          </div>
        </Link>
      </div>
      <Link to="/home" className="decoration-transparent">
        <img
          className="absolute h-[13px] w-[13px] top-[4%] right-[4%]  max-w-full overflow-hidden max-h-full"
          alt=""
          src="/close.svg"
        />
      </Link>
    </div>
  );
};

export default ThanksModal;
